import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PaginationComponent } from "./pagination.component";
import { PaginationService } from "./pagination.service";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import {
    NgbPaginationModule,
    NgbButtonsModule,
    NgbModule,
} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
    declarations: [PaginationComponent],
    imports: [
        CommonModule,
        NgbPaginationModule,
        FormsModule,
        NgbButtonsModule,
        NgbModule,
        TranslateModule
    ],
    exports: [PaginationComponent],
    providers: [],
})
export class PaginationModule {
    static forRoot(): ModuleWithProviders<PaginationModule> {
        return {
            ngModule: PaginationModule,
            providers: [PaginationService],
        };
    }
}
